import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, browserLocalPersistence, getAuth, initializeAuth, signInWithCustomToken } from 'firebase/auth';
import { Observable, from, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { appEnv } from '../../app.config';
import { FirebaseAppService } from './firebase-app.service';

interface FirebaseTokenResponse {
  firebase_uid: string;
  custom_token: string;
}

@Injectable({
  providedIn: 'root'
})
export class DirectMessageAuthService {
  private auth: Auth;
  private uid: string | null = null;
  private signIn$: Observable<string> | null = null;

  constructor(private httpClient: HttpClient, private firebaseAppService: FirebaseAppService) {
    const app = this.firebaseAppService.getApp();

    try {
      this.auth = initializeAuth(app, { persistence: browserLocalPersistence });
    } catch {
      this.auth = getAuth(app);
    }
  }

  ensureSignedIn(): Observable<string> {
    if (this.uid) {
      return of(this.uid);
    }

    if (!this.signIn$) {
      this.signIn$ = this.httpClient
        .post<FirebaseTokenResponse>(`${appEnv.api}crm/messaging/firebase-token`, {})
        .pipe(
          switchMap((res) =>
            from(signInWithCustomToken(this.auth, res.custom_token)).pipe(
              map(() => {
                this.uid = res.firebase_uid;
                return res.firebase_uid;
              })
            )
          ),
          shareReplay(1)
        );
    }

    return this.signIn$;
  }

  get myUid(): string | null {
    return this.uid;
  }
}
